import React from "react";
import { Navigate, useParams } from "react-router-dom";
import { CustomerStatus } from "store/auth";
import { useVerifyEmailToken } from "pages/informations/info.service";
import { Button, Form, InputField } from "components/form";
import Maximum from "assets/images/svg/maximum_number_exceeded_code.svg";
import { t } from "i18next";

function EmailVerificationPage({ toURL = "/info/congratulations", fallback = "/register" ,loading = false }) {
  const [password, setPassword] = React.useState("");

  function handleVerify(data: any) {
    setPassword(data.password);
  }

  if (password) return <VerificationStep password={password} toURL={toURL} fallback={fallback} />;

  return (
    <div className="registration link-send">
      <div className="row">
        <div className="col-lg-8 col-md-12 mx-auto">
          <div className="row">
            <div className="col-lg-6 col-md-4">
              <img className="background" src={Maximum} alt="background" />
            </div>
            <div className="col-lg-6 col-md-8">
              <div className="box-linksend">
                <h1>{t('signup:enterYourPass')as string}</h1>
                <div>
                  <Form onSubmit={handleVerify}>
                    <InputField
                      id="password"
                      type="password"
                      label={t('signup:password')as string}
                      rules={{ required: "errors:required" }}
                    />
                    <Button className='btn-blue' isLoading={loading}>{t('signup:submit')as string}</Button>
                  </Form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function VerificationStep({ password, toURL, fallback }: { password: string; toURL: string; fallback: string }) {
  const { token } = useParams();

  const { preregisterData ,isLoading } = useVerifyEmailToken(fallback, {
    data: {
      token,
      password,
      isVerificationLink: true
    }
  });
  if (preregisterData?.expiryDate) return <Navigate to="/info/link-expired" />;
  if (preregisterData?.status === CustomerStatus.Registered) return <Navigate to={toURL} />;

  return (
    <div>
      <EmailVerificationPage fallback={fallback} toURL={toURL} loading={isLoading} />
    </div>
  );
}

export default EmailVerificationPage;
